import { lazy } from "react"
import {
  HIVES_LIST_VIEW,
  EDIT_HIVE_VIEW,
  HIVE_VIEW,
  NEW_HIVE_FOR_APIARY_VIEW,
  NEW_HIVE_VIEW,
} from "@/features/bees/routes/route-list.ts"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllHives = lazy(
  () => import("@/features/bees/views/hives/all-hives/all-hives.tsx"),
)
const EditHiveView = lazy(
  () => import("@/features/bees/views/hives/edit-hive-view/edit-hive-view.tsx"),
)
const HiveView = lazy(
  () => import("@/features/bees/views/hives/hive-view/hive-view.tsx"),
)
const NewHiveView = lazy(
  () => import("@/features/bees/views/hives/new-hive-view/new-hive-view.tsx"),
)
export const hivesRoutes = [
  {
    path: HIVES_LIST_VIEW,
    element: <AllHives />,
  },
  {
    path: NEW_HIVE_FOR_APIARY_VIEW,
    element: <NewHiveView />,
  },
  {
    path: NEW_HIVE_VIEW,
    element: <NewHiveView />,
  },
  {
    path: HIVE_VIEW,
    element: <HiveView />,
  },
  {
    path: EDIT_HIVE_VIEW,
    element: <EditHiveView />,
  },
  {
    path: EDIT_HIVE_VIEW,
    element: <EditHiveView />,
  },
]

const MOBILE_HIVES_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: hivesRoutes,
  },
]

const DESKTOP_HIVES_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: hivesRoutes,
  },
]

export const getHivesRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_HIVES_ROUTES : MOBILE_HIVES_ROUTES
}
